import {Checkbox, Dropdown, Form, Modal} from "semantic-ui-react";
import React, {Component} from "react";

export default class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {countryOptions: [], precrkoptions: []};
    }


    close = () => this.props.closeSettings();

    async getLangs() {
        if (this.state.countryOptions.length === 0) {
            const response = await fetch(Settings.load("server") + '/langs', {method: 'POST'});
            let langs = await response.json();
            const response1 = await fetch(Settings.load("server") + '/pre_langs', {method: 'POST'});
            let precrklangs = await response1.json();
            this.setState({
                countryOptions: langs.map(a => ({key: a.code, value: a.code, text: a.name})),
                precrkoptions: precrklangs.map(a => ({
                    key: a.script,
                    value: a.script,
                    text: "Iz " + a.iz + " v " + a.v
                }))
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen !== prevProps.isOpen) {
            if (this.props.isOpen) {
                this.getLangs();
            }
        }
    }

    render() {
        return (<Modal dimmer={'blurring'} open={this.props.isOpen} onClose={this.close} size={"mini"}>
            <Modal.Header>Nastavitve</Modal.Header>
            <Modal.Content style={{textAlign: "center"}}>
                <Modal.Description>
                    <Form style={{overflow: "inherit"}}>
                        <Form.Field>
                            <label>Jezik frivole</label>
                            <Dropdown placeholder='Izberi jezik frivole' fluid search selection
                                      options={this.state.countryOptions} defaultValue={Settings.load("lang")}
                                      onChange={(e, s) => {
                                          this.handleChange("lang", s);
                                          this.props.refresh();
                                      }}/>

                            <label>Način prečrkovanja</label>
                            <Dropdown disabled={"true" === Settings.load("biblio")}
                                      placeholder='Izberi način prečrkovanja' fluid search selection
                                      options={this.state.precrkoptions}
                                      defaultValue={parseInt(Settings.load("pre_lang"),10)}
                                      onChange={(e, s) => {
                                          this.handleChange("pre_lang", s);
                                          this.props.refresh();
                                      }}/>
                            <label>Bibliografski način</label>
                            <Checkbox toggle defaultChecked={Settings.load("biblio") === "true"} onChange={(e, s) => {
                                Settings.save("biblio", s.checked);
                                this.props.refresh();
                            }}/>
                        </Form.Field>
                        <div style={{textAlign: "center"}}><b>{Settings.load("v")}</b>
                        </div>
                        <div>{Settings.load("server")}</div>
                    </Form>
                </Modal.Description>
            </Modal.Content>
        </Modal>)
    };

    handleChange(e, s) {
        Settings.save(e, s.value)
    }

    static load(key) {
        return window.localStorage.getItem(key);
    }

    static save(key, val) {
        window.localStorage.setItem(key, val);
    }
}


// WEBPACK FOOTER //
// ./src/components/settings/Settings.js